import { AfterViewInit, ChangeDetectionStrategy, Component, QueryList, ViewChildren } from '@angular/core';
import { TemplateDirective } from '@fleet-beat/core';
import { DataAutocompletePresetsService } from '../services/data-autocomplete-presets.service';

@Component({
  selector: 'fb-data-autocomplete-templates',
  templateUrl: './data-autocomplete-templates.component.html',
  styleUrls: ['./data-autocomplete-templates.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DataAutocompleteTemplatesComponent implements AfterViewInit {
  @ViewChildren(TemplateDirective) templates: QueryList<TemplateDirective<object>>;

  constructor(private dataAutocompletePresetsService: DataAutocompletePresetsService) {}

  ngAfterViewInit(): void {
    this.dataAutocompletePresetsService.setTemplates(this.templates.toArray());
  }
}
